import PlaceOrder from '@/pages/PlaceOrder'

export default {
    path: '',
    component: PlaceOrder,
    children: [
        {
            path: '/place/order/:ref',
            name: 'Place Order',
            component: PlaceOrder,
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/placeorder.js